import React, { useEffect, useRef, useState } from 'react';
import { Input, Select } from "antd";
import DashboardHero from '../../components/dashboard2/dashboard-hero/component';
import DashboardCards from '../../components/dashboard2/dashboard-cards/component';
import Amenities from '../../components/dashboard2/amenities/component';
import { Reviews } from '../../components/dashboard2/reviews';
import HotelInformation from '../../components/dashboard2/hotel-inforamation/component';
import { Base64 } from 'js-base64';
import { useLocation } from 'react-router-dom';
import { DashboardHeroSkeleton } from '../../components/dashboard2/dashboard-hero-skeleton';
import FlexRoomSkeleton from '../../components/dashboard2/flex-room-skeleton/component';
import DashboardCardsSkeleton from '../../components/dashboard2/dashboard-cards-skeleton/component';
import ErrorMessage from '../../components/common/error-message/component';
import { useParams } from 'react-router-dom';
import { QUERY_PARAMS } from '../../../constants/index';
import { useSelector } from 'react-redux';
import { ISavedPropertiesState } from '@store/slices';
import { axiosInstance } from '@share/utils';
import { ILoginState } from '@share/store/slices';
import HotelDetailTopNav from '../../components/dashboard2/hotel-detail-top-nav/component';
import { PriceHighToLow, PriceLowToHigh } from '@common-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { BlueButton } from '@share/components';
import { isEmpty } from 'lodash';
import { GET_CUSTOMER_LOYALTY } from '@share/constants';
import './style.scss';

interface IMapStateToProps {
  savedPropertiesStore: ISavedPropertiesState;
}

const DashboardHotel = () => {
  const location = useLocation();
  const login = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { account } = login;
  const currency = String(account?.currency ?? 'USD');
  const [hotelData, setHotelData] = useState<any>(null);
  const [sessionKey, setSessionKey] = useState();
  const [loading, setLoading] = useState(true);
  const { Option } = Select;
  const savedPropertiesStore = useSelector((state: IMapStateToProps) => state.savedPropertiesStore);
  const [selectedValue, setSelectedValue] = useState(`${PriceLowToHigh}`);
  const [customerLoyalty, setCustomerLoyalty] = useState<string>(localStorage.getItem(GET_CUSTOMER_LOYALTY) ?? '')

  const handleChange = (value: any) => {
    const sortedPackages = adjustedPackageGroups.sort((a: any, b: any) => {
      const priceA = a.groupedPackages[0]?.price || 0;
      const priceB = b.groupedPackages[0]?.price || 0;
      return value === `${PriceLowToHigh}` ? priceA - priceB : priceB - priceA;
    });
    setSelectedValue(value);
  };



  async function fetchHotels(payload) {
    try {
      const { data: result } = await axiosInstance.post('/hotels/hotel', payload);
      setHotelData(result || []);
      if (result?.sessionKey) {
        setSessionKey(result.sessionKey);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const { hotelDetails, roomsContent, adjustedPackageGroups } = hotelData || {};
  const { id } = useParams<any>();

  const {
    title: hotelName,
    images,
    address: hotelAddress,
    city,
    state,
    zipCode,
    amenities,
    starRating,
    reviews,
    reviewsCount,
    comfort,
    cleanliness,
    phone,
    checkInInformation,
    checkOutInformation,
    pets,
    guestRatings,
    otherImportantInformation,
    descriptions,
  } = hotelDetails || {};

  const parseQueryParams = () => {
    const queryParams = new URLSearchParams(location.search);
    const rooms = JSON.parse(Base64.decode(queryParams.get(QUERY_PARAMS.ROOMS) ?? 'null'));
    const locationData = JSON.parse(
      Base64.decode(queryParams.get(QUERY_PARAMS.LOCATION) ?? 'null'),
    );
    const dateObject = JSON.parse(Base64.decode(queryParams.get(QUERY_PARAMS.DATE) ?? 'null'));
    const sessionKey = JSON.parse(
      Base64.decode(queryParams.get(QUERY_PARAMS.SESSION_KEY) ?? 'null'),
    );

    return { id, rooms, locationData, dateObject, sessionKey };
  };

  const { locationData: parsedLocationData, dateObject: parsedDateObject, rooms } = parseQueryParams();

  const { process, error } = savedPropertiesStore;
  useEffect(() => {
    if (process && hotelData?.hotelDetails?.id == process.id) {
      hotelData.hotelDetails.savedProperty = process.added;
      setHotelData(hotelData);
    }
  }, [process]);

  const buildPayload = () => {
    const { id, rooms, dateObject, sessionKey } = parseQueryParams();
    setSessionKey(sessionKey);

    let payload: any = {};

    if (id) {
      payload = {
        marginator: {
          percentage: 0,
        },
        sessionKey: {
          ...sessionKey,
        },
        hotelRequest: {
          residency: 'US',
          location: '657822',
          checkIn: dateObject.checkIn,
          checkOut: dateObject.checkOut,
          rooms,
          hotelId: id,
        },
        currency: currency,
        lifeStyle: null,
      };

      if (!isEmpty(customerLoyalty)) {
        payload.customerLoyalty = customerLoyalty
      } else {
        delete payload.customerLoyalty;
      }
    } else {
      setLoading(false);
    }

    return payload;
  }

  const handleUpdateHotels = (customerLoyalty?: string) => {
    setLoading(true);
    const queryParams = new URLSearchParams(window.location.search);
    const dateObject = JSON.parse(Base64.decode(queryParams.get(QUERY_PARAMS.DATE) ?? 'null'));
    const rooms = JSON.parse(Base64.decode(queryParams.get(QUERY_PARAMS.ROOMS) ?? 'null'));
    const sessionKey = JSON.parse(
      Base64.decode(queryParams.get(QUERY_PARAMS.SESSION_KEY) ?? 'null'),
    );
    setSessionKey(sessionKey);
    const payload: any = {
      marginator: {
        percentage: 0,
      },
      sessionKey: {
        ...sessionKey,
      },
      hotelRequest: {
        residency: 'US',
        location: '657822',
        checkIn: dateObject.checkIn,
        checkOut: dateObject.checkOut,
        rooms,
        hotelId: id,
      },
      currency: currency,
      lifeStyle: null,
    };
    if (!isEmpty(customerLoyalty)) payload.customerLoyalty = customerLoyalty;
    fetchHotels(payload);
  };

  const intl = useIntl();

  const handleChangeCustomerLoyalty = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCustomerLoyalty(e.target.value);
  };

  const handleSubmitCustomerLoyalty = () => {
    localStorage.setItem(GET_CUSTOMER_LOYALTY, customerLoyalty)
    setLoading(true);
    fetchHotels(buildPayload());
  };

  const cleanCustomerLoyalty = () => {
    localStorage.removeItem(GET_CUSTOMER_LOYALTY);
    setCustomerLoyalty('');
    setLoading(true);
  }

  const hasTVP = adjustedPackageGroups?.some(item =>
    item.groupedPackages.some(pkg => pkg.supplierId === "TVP")
  ) ?? false;

  useEffect(() => {
    fetchHotels(buildPayload());
  }, []);

  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    if (isEmpty(customerLoyalty)) {
      fetchHotels(buildPayload());
    }
  }, [customerLoyalty]);

  useEffect(() => {
    if (!hasTVP) {
      localStorage.removeItem(GET_CUSTOMER_LOYALTY);
      setCustomerLoyalty('');
    }
  }, [hasTVP])


  return (
    <div>
      <HotelDetailTopNav
        location={parsedLocationData}
        checkInDate={parsedDateObject.checkIn}
        checkOutDate={parsedDateObject.checkOut}
        rooms={rooms}
        sessionKey={sessionKey}
        handleUpdateHotels={handleUpdateHotels}
        loading={loading}
      />
      {loading ? (
        <>
          <DashboardHeroSkeleton />
          <FlexRoomSkeleton />
          <section className="pt-0">
            <a id="rooms"></a>
            <div className="container" data-sticky-container>
              <div className="row g-4 g-xl-5">
                <div className="col-xl-12 order-1">
                  <div className="vstack gap-4">
                    <DashboardCardsSkeleton />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          {hotelDetails ? (
            <>
              <DashboardHero
                hotelName={hotelName}
                hotelAddress={hotelAddress}
                city={city}
                state={state}
                zipCode={zipCode}
                images={images}
                hotelData={hotelData}
              />
              <section className="pt-0">
                <div className="container" data-sticky-container>

                  {(hasTVP) && (
                    <div className="container__header-customer-loyalty">
                      <h4>
                        <FormattedMessage id="Customer Loyalty" />
                      </h4>

                      <div className="container__header-customer-loyalty-inputs" style={{ marginBottom: '30px' }}>
                        <Input
                          placeholder="Customer Loyalty"
                          value={customerLoyalty}
                          onChange={handleChangeCustomerLoyalty}
                          className='container__header-customer-loyalty-inputs-input'
                        />
                        <BlueButton
                          onClick={handleSubmitCustomerLoyalty}
                          disabled={isEmpty(customerLoyalty)}
                          style={{ marginRight: '5px' }}>
                          <FormattedMessage id="search" defaultMessage="Search" />
                        </BlueButton>
                        <BlueButton
                          onClick={cleanCustomerLoyalty}
                          disabled={isEmpty(customerLoyalty)}
                          reverse>
                          <FormattedMessage id="reset" defaultMessage="Reset" />
                        </BlueButton>
                      </div>
                    </div>
                  )}

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold mb-0">
                      <FormattedMessage id="room.search.room_availability" /> {adjustedPackageGroups?.length}
                    </h6>
                    <div className='d-flex jusity-content-end'>
                      <Select
                        value={selectedValue}
                        onChange={handleChange}
                        style={{ width: 200 }}
                      >
                        <Option value={PriceLowToHigh}>{intl.formatMessage({ id: 'sort.priceLowToHigh' })}</Option>
                        <Option value={PriceHighToLow}>{intl.formatMessage({ id: 'sort.priceHighToLow' })}</Option>
                      </Select>
                    </div>
                  </div>

                  <div className="order-1">
                    <div className="gap-4">
                      <DashboardCards
                        adjustedPackageGroups={adjustedPackageGroups}
                        location={parsedLocationData}
                        dateObject={parsedDateObject}
                        rooms={rooms}
                        roomsContent={roomsContent}
                        sessionKey={sessionKey}
                      />
                      {amenities?.length > 1 && <Amenities categories={amenities} />}
                      <Reviews
                        guestRatings={guestRatings}
                        reviews={reviews}
                        starRating={starRating}
                        reviewsCount={reviewsCount}
                        comfort={comfort}
                        cleanliness={cleanliness}
                      />
                      <HotelInformation
                        checkOutInformation={checkOutInformation[0]}
                        checkInInformation={checkInInformation[1]}
                        phone={phone}
                        pets={pets}
                        otherImportantInformation={otherImportantInformation}
                        descriptions={descriptions}
                      />
                    </div>
                  </div>
                </div>
              </section>
            </>
          ) : (
            <div className="mb-6">
              <ErrorMessage
                heading="The room you selected is no longer available"
                subHeading="This hotel has confirmed that the room with the properties you selected is no longer available at this time"
                text="Don't worry! Try again but changing your search criteria"
                button="search again"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export { DashboardHotel };
